import React from "react";
import { useI18n } from "../i18n/I18nContext";

const PROVIDER = {
  name: "Demetrio Campolo",
  street: "Mintarder Weg 29",
  city: "40472 Düsseldorf",
  country: { it: "Germania", en: "Germany", de: "Deutschland", es: "Alemania", fr: "Allemagne", ja: "ドイツ" },
  email: "info@webmabw.com",
  phone: "+49 15146339043",
};

const CONTENT = {
  it: {
    title: "Note legali (Impressum)",
    sub: "Informazioni obbligatorie ai sensi del § 5 DDG (Germania).",
    provider: "Responsabile del sito",
    contact: "Contatti",
    email: "Email",
    phone: "Telefono",
    responsible: "Responsabile dei contenuti ai sensi del § 18 Abs. 2 MStV",
    odr_title: "Risoluzione delle controversie",
    odr_body:
      "La Commissione europea mette a disposizione una piattaforma per la risoluzione online delle controversie (ODR): https://ec.europa.eu/consumers/odr/. La nostra email è indicata sopra. Non siamo disponibili né obbligati a partecipare a procedure di risoluzione delle controversie davanti a un organismo di conciliazione dei consumatori.",
    liability_content_title: "Responsabilità per i contenuti",
    liability_content_body:
      "In qualità di fornitore di servizi, siamo responsabili dei contenuti propri di queste pagine ai sensi del § 7 comma 1 DDG e delle leggi generali. Ai sensi dei §§ 8-10 DDG non siamo tuttavia tenuti a monitorare informazioni di terzi trasmesse o memorizzate, né a ricercare circostanze che facciano supporre attività illecite. Gli obblighi di rimozione o blocco dell'uso delle informazioni ai sensi delle leggi generali rimangono impregiudicati. Una responsabilità in tal senso è possibile solo dal momento in cui veniamo a conoscenza di una concreta violazione del diritto. Non appena ne saremo informati, provvederemo a rimuovere immediatamente tali contenuti.",
    liability_links_title: "Responsabilità per i link",
    liability_links_body:
      "Il nostro sito contiene link a siti web di terzi sui cui contenuti non abbiamo alcuna influenza. Per tali contenuti esterni non possiamo quindi assumerci alcuna responsabilità: ciascun gestore o operatore dei siti collegati è responsabile dei propri contenuti.",
    copyright_title: "Diritto d'autore",
    copyright_body:
      "I contenuti e le opere create dai gestori del sito sono soggetti al diritto d'autore tedesco. La riproduzione, modifica, distribuzione e ogni forma di utilizzo al di fuori dei limiti del diritto d'autore richiedono il consenso scritto dell'autore o del creatore.",
  },
  en: {
    title: "Legal notice (Impressum)",
    sub: "Mandatory information under § 5 DDG (Germany).",
    provider: "Site operator",
    contact: "Contact",
    email: "Email",
    phone: "Phone",
    responsible: "Responsible for content under § 18 (2) MStV",
    odr_title: "Dispute resolution",
    odr_body:
      "The European Commission provides a platform for online dispute resolution (ODR): https://ec.europa.eu/consumers/odr/. Our email address is listed above. We are neither willing nor obliged to participate in dispute resolution proceedings before a consumer arbitration body.",
    liability_content_title: "Liability for content",
    liability_content_body:
      "As a service provider, we are responsible for our own content on these pages in accordance with § 7 (1) DDG and the general laws. However, according to §§ 8 to 10 DDG, we are not obliged to monitor transmitted or stored third-party information, nor to investigate circumstances that indicate illegal activity. Obligations to remove or block the use of information under general laws remain unaffected. Liability in this respect is only possible from the time we become aware of a specific infringement. As soon as we become aware of such infringements, we will remove the content immediately.",
    liability_links_title: "Liability for links",
    liability_links_body:
      "Our site contains links to external third-party websites over whose content we have no influence. We therefore cannot accept any liability for these external contents — the respective provider or operator is responsible for the content of the linked sites.",
    copyright_title: "Copyright",
    copyright_body:
      "The content and works created by the site operators on these pages are subject to German copyright law. Duplication, processing, distribution and any form of exploitation outside the limits of copyright require the written consent of the respective author or creator.",
  },
  de: {
    title: "Impressum",
    sub: "Angaben gemäß § 5 DDG.",
    provider: "Diensteanbieter",
    contact: "Kontakt",
    email: "E-Mail",
    phone: "Telefon",
    responsible: "Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV",
    odr_title: "Streitschlichtung",
    odr_body:
      "Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr/. Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
    liability_content_title: "Haftung für Inhalte",
    liability_content_body:
      "Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.",
    liability_links_title: "Haftung für Links",
    liability_links_body:
      "Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.",
    copyright_title: "Urheberrecht",
    copyright_body:
      "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.",
  },
  es: {
    title: "Aviso legal (Impressum)",
    sub: "Información obligatoria conforme al § 5 DDG (Alemania).",
    provider: "Responsable del sitio",
    contact: "Contacto",
    email: "Email",
    phone: "Teléfono",
    responsible: "Responsable del contenido según § 18 (2) MStV",
    odr_title: "Resolución de conflictos",
    odr_body:
      "La Comisión Europea pone a disposición una plataforma para la resolución de conflictos en línea (ODR): https://ec.europa.eu/consumers/odr/. Nuestro correo electrónico se indica arriba. No estamos dispuestos ni obligados a participar en procedimientos de resolución de conflictos ante un organismo de arbitraje de consumo.",
    liability_content_title: "Responsabilidad por los contenidos",
    liability_content_body:
      "Como proveedor de servicios, somos responsables de los contenidos propios de estas páginas conforme al § 7 (1) DDG y a las leyes generales. Sin embargo, según los §§ 8 a 10 DDG no estamos obligados a supervisar información de terceros transmitida o almacenada, ni a investigar circunstancias que indiquen actividades ilícitas. Las obligaciones de retirar o bloquear el uso de información conforme a las leyes generales no se ven afectadas. La responsabilidad al respecto sólo es posible a partir del momento en que tengamos conocimiento de una infracción concreta. Cuando tengamos conocimiento de tales infracciones, retiraremos los contenidos correspondientes de inmediato.",
    liability_links_title: "Responsabilidad por los enlaces",
    liability_links_body:
      "Nuestro sitio contiene enlaces a sitios web externos de terceros sobre cuyos contenidos no tenemos influencia. Por ello no podemos asumir ninguna responsabilidad por estos contenidos externos: el proveedor u operador correspondiente es responsable de los contenidos de las páginas enlazadas.",
    copyright_title: "Derechos de autor",
    copyright_body:
      "Los contenidos y obras creados por los operadores del sitio en estas páginas están sujetos a la legislación alemana sobre derechos de autor. La reproducción, modificación, distribución y cualquier forma de explotación fuera de los límites de los derechos de autor requieren el consentimiento por escrito del autor o creador correspondiente.",
  },
  fr: {
    title: "Mentions légales (Impressum)",
    sub: "Informations obligatoires selon le § 5 DDG (Allemagne).",
    provider: "Responsable du site",
    contact: "Contact",
    email: "Email",
    phone: "Téléphone",
    responsible: "Responsable du contenu selon § 18 (2) MStV",
    odr_title: "Règlement des litiges",
    odr_body:
      "La Commission européenne met à disposition une plateforme de règlement en ligne des litiges (RLL) : https://ec.europa.eu/consumers/odr/. Notre email figure ci-dessus. Nous ne sommes ni disposés ni tenus de participer à une procédure de règlement des litiges devant un organisme d'arbitrage de consommation.",
    liability_content_title: "Responsabilité pour les contenus",
    liability_content_body:
      "En tant que prestataire de services, nous sommes responsables des contenus propres à ces pages conformément au § 7 (1) DDG et aux lois générales. Selon les §§ 8 à 10 DDG, nous ne sommes toutefois pas tenus de surveiller les informations tierces transmises ou stockées, ni de rechercher des circonstances indiquant une activité illicite. Les obligations de retrait ou de blocage de l'utilisation des informations selon les lois générales ne sont pas affectées. Une responsabilité à cet égard n'est possible qu'à partir du moment où nous avons connaissance d'une violation concrète. Dès que nous en aurons connaissance, nous retirerons immédiatement ces contenus.",
    liability_links_title: "Responsabilité pour les liens",
    liability_links_body:
      "Notre site contient des liens vers des sites externes tiers sur le contenu desquels nous n'avons aucune influence. Nous ne pouvons donc assumer aucune responsabilité pour ces contenus externes : le fournisseur ou l'opérateur respectif est responsable du contenu des pages liées.",
    copyright_title: "Droits d'auteur",
    copyright_body:
      "Les contenus et œuvres créés par les opérateurs du site sur ces pages sont soumis au droit d'auteur allemand. La reproduction, la modification, la distribution et toute forme d'exploitation en dehors des limites du droit d'auteur nécessitent le consentement écrit de l'auteur ou du créateur respectif.",
  },
  ja: {
    title: "法的通知（Impressum）",
    sub: "ドイツ § 5 DDG に基づく必須情報。",
    provider: "サイト運営者",
    contact: "連絡先",
    email: "メール",
    phone: "電話",
    responsible: "§ 18 (2) MStV に基づくコンテンツ責任者",
    odr_title: "紛争解決",
    odr_body:
      "欧州委員会はオンライン紛争解決（ODR）プラットフォームを提供しています：https://ec.europa.eu/consumers/odr/。当方のメールアドレスは上記に記載しています。当方は消費者仲裁機関での紛争解決手続きに参加する意思も義務もありません。",
    liability_content_title: "コンテンツの責任",
    liability_content_body:
      "サービス提供者として、当方は § 7 (1) DDG および一般法に従い、これらのページの自己コンテンツについて責任を負います。しかし、§§ 8 から 10 DDG によれば、送信または保存された第三者情報を監視したり、違法行為を示す状況を調査したりする義務はありません。一般法に基づく情報の削除または利用停止の義務は影響を受けません。この点における責任は、具体的な違反を認識した時点からのみ生じます。そのような違反を認識次第、直ちに該当コンテンツを削除します。",
    liability_links_title: "リンクの責任",
    liability_links_body:
      "当サイトには第三者の外部ウェブサイトへのリンクが含まれており、当方はその内容に影響を及ぼすことはできません。したがって、これらの外部コンテンツについて当方は責任を負うことができません。リンク先のページの内容については、各提供者または運営者が責任を負います。",
    copyright_title: "著作権",
    copyright_body:
      "サイト運営者が作成したこれらのページ上のコンテンツおよび作品は、ドイツの著作権法の対象となります。著作権の範囲を超える複製、加工、配布、およびあらゆる形態の利用には、各作者または制作者の書面による同意が必要です。",
  },
};

function Section({ title, children }) {
  return (
    <section className="card-mabw p-6 md:p-8">
      <h2 className="text-lg md:text-xl font-semibold mb-3 text-mabw-text" style={{ fontFamily: "Outfit" }}>{title}</h2>
      <div className="text-mabw-soft space-y-1">{children}</div>
    </section>
  );
}

export default function Impressum() {
  const { lang } = useI18n();
  const c = CONTENT[lang] || CONTENT.it;
  const country = PROVIDER.country[lang] || PROVIDER.country.it;

  const odrParts = c.odr_body.split("https://ec.europa.eu/consumers/odr/");

  return (
    <div className="max-w-3xl mx-auto px-6 md:px-12 py-12 md:py-16 anim-fade-up" data-testid="impressum-page">
      <div className="text-xs uppercase tracking-[0.22em] text-mabw-secondary font-semibold mb-2">MABW</div>
      <h1 className="text-3xl md:text-4xl font-semibold leading-tight" style={{ fontFamily: "Outfit" }}>
        {c.title}
      </h1>
      <p className="text-mabw-soft mt-3">{c.sub}</p>

      <div className="mt-10 space-y-8 text-sm md:text-base leading-relaxed">
        <Section title={c.provider}>
          <p>{PROVIDER.name}</p>
          <p>{PROVIDER.street}</p>
          <p>{PROVIDER.city}</p>
          <p>{country}</p>
        </Section>

        <Section title={c.contact}>
          <p>
            {c.email}: <a href={`mailto:${PROVIDER.email}`} className="text-mabw-primary hover:underline">{PROVIDER.email}</a>
          </p>
          <p>
            {c.phone}: <a href={`tel:${PROVIDER.phone.replace(/\s/g, "")}`} className="text-mabw-primary hover:underline">{PROVIDER.phone}</a>
          </p>
        </Section>

        <Section title={c.responsible}>
          <p>{PROVIDER.name}</p>
          <p>{PROVIDER.street}, {PROVIDER.city}</p>
        </Section>

        <Section title={c.odr_title}>
          <p>
            {odrParts.map((part, i) => (
              <React.Fragment key={`odr-part-${part.slice(0, 12)}-${i}`}>
                {part}
                {i < odrParts.length - 1 && (
                  <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-mabw-primary hover:underline">
                    https://ec.europa.eu/consumers/odr/
                  </a>
                )}
              </React.Fragment>
            ))}
          </p>
        </Section>

        <Section title={c.liability_content_title}>
          <p>{c.liability_content_body}</p>
        </Section>

        <Section title={c.liability_links_title}>
          <p>{c.liability_links_body}</p>
        </Section>

        <Section title={c.copyright_title}>
          <p>{c.copyright_body}</p>
        </Section>
      </div>
    </div>
  );
}
